module.exports = __webpack_public_path__ + "img/Powerful-religious-tattoo-Designs-to-Try-58.jpg";